import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import { Formik, Form, ErrorMessage } from 'formik';
import config from '../../config';
import FloatingLabel from "floating-label-react";
import "floating-label-react/styles.css";

import { LoginSchema } from './validation';
import { login, checkAuthorization } from './actions';
import { loginUsingGoogle, loginUsingFacebook } from '../registration/actions';
import { PAGE_ROUTES } from '../../constants/pageRoutes';
import ShowSuccessToasts from './successToast';
import ShowErrorToasts from './errorToast';
import { FACEBOOK_LOGO, PASSWORD_HIDE, PASSWORD_SHOW } from '../../constants/images';

const mapStateToProps = state => ({
  global: state.Global,
  errors: state.Global.errors,
  successes: state.Global.successes
});

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowingPassword: false,
    }

    this.onGoogleSignin = this.onGoogleSignin.bind(this);
    this.onFacebookSignin = this.onFacebookSignin.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    let { global, dispatch } = this.props;

    if (global.token) {
      dispatch(checkAuthorization());
    }
  }

  onBack = () => {
    let { history } = this.props;
    history.push(PAGE_ROUTES.CREATE_ACCOUNT);
  }

  handleSubmit = (values, form) => {
    const { dispatch } = this.props;
    dispatch(login(values));
  }

  onGoogleSignin = (response, values) => {
    if (!response.tokenId)
      return;

    const { dispatch } = this.props;
    dispatch(loginUsingGoogle(response.tokenId));
  }

  onFacebookSignin = (response, values) => {
    if (!response.accessToken)
      return;

    const { dispatch } = this.props;
    dispatch(loginUsingFacebook(response.accessToken));
  }

  render() {

    return (
      <div className="main-container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Hi, Welcome Back</h1>
                <p className="detail-text">Please Sign In to CollegeWeekends with your original account details.</p>
                <Formik
                  validationSchema={LoginSchema}
                  initialValues={{
                    email: '',
                    password: ''
                  }}
                  onSubmit={this.handleSubmit}>
                  {formProps => (
                    <Form>
                      <div className="signin-page">
                        <div className="account-section">
                          <GoogleLogin
                            clientId={config.googleLoginClientId}
                            buttonText="Continue with Google"
                            onSuccess={response => this.onGoogleSignin(response, formProps.values)}
                            cookiePolicy={'single_host_origin'}
                            className="account-box"
                            prompt="select_account"
                          />
                          <div className="fb-box">
                            <FacebookLogin
                              appId={config.facebookLoginAppId}
                              fields="name,email,picture"
                              callback={response => this.onFacebookSignin(response, formProps.values)}
                              cssClass="account-box"
                              isMobile={false}
                              textButton="Continue with Facebook"
                              authType='reauthenticate'
                            />
                            <img src={FACEBOOK_LOGO} className="facebook-icon" alt="email" />
                          </div>
                        </div>
                        <div className="signin-detail">
                          <div className="text-detail">
                            Sign In
                          </div>
                        </div>

                        <div className="form-section">
                          <div>
                            <div className="form-group">
                              <FloatingLabel
                                type="email"
                                id="email"
                                className="form-control"
                                name="email"
                                placeholder="Email Address"
                                value={formProps.values.email}
                                onChange={formProps.handleChange}
                              />
                              <ErrorMessage name='email' render={msg => <div className="invalid-feedback">{msg}</div>} />
                            </div>
                            <div className="form-group">
                              <FloatingLabel
                                id="password"
                                type={this.state.isShowingPassword ? 'text' : 'password'}
                                placeholder="Password"
                                name="password"
                                className="form-control password-control"
                                value={formProps.values.password}
                                onChange={formProps.handleChange}
                              />
                              <ErrorMessage
                                name='password' render={msg => <div className="invalid-feedback">{msg}</div>} />
                              <div className="password-section">
                                <img
                                  src={this.state.isShowingPassword ? PASSWORD_SHOW : PASSWORD_HIDE}
                                  className="password-icon" alt="password"
                                  onClick={() => {
                                    this.setState({ isShowingPassword: !this.state.isShowingPassword })
                                  }} />
                              </div>
                            </div>
                          </div>
                          <div className="forogt-password-text">
                            <Link to={PAGE_ROUTES.RESET_PASSWORD}>Forgot Password?</Link>
                          </div>
                          <div className="combo-button">
                            <div className="signin-button">
                              <button type="submit" className="btn primary">Sign In</button>
                            </div>
                          </div>
                          <div className="no-account-detail">
                            <p className="account-text">Don't have an account? <Link to={PAGE_ROUTES.CREATE_ACCOUNT} className="signup-link">Sign Up</Link></p>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>

              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div >
    )
  }
}

export default withRouter(connect(mapStateToProps)(Login));
